import { allTestListGet } from "api/allTestListApi";
import React, { useEffect, useState, useReducer } from "react";
import { AllTestContext } from "../store/allTestStore";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { arrayValidation } from "helper/validation";
import { useHistory } from "react-router";
import { sortBy } from "helper/sortBy";
import { Radio } from "antd";
import {
  setParams,
  setSortByState,
  fetchAllOfflineSyncTest,
} from "action/actions";
import { HelperContext } from "store/helperStore.jsx";
import { TestTempModal } from "components/TestView/TestTempModal";
import { Tooltip } from "antd";

const FlagedQuestion = (props) => {
  const history = useHistory();
  const { allTestC, dispatchAllTest } = AllTestContext();
  const [state, setState] = useState({
    selectAll: false,
    selectTest: {},
    selectAllBtn: true,
  });

  const { helperC, dispatchHelper } = HelperContext();
  const initData = {
    testData: "",
    testIndex: "",
    what: "", //actualAns
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TEST_INDEX": {
        return {
          ...state,
          testIndex: action.payload,
        };
      }
      case "SET_TEST_DATA":
        return {
          ...state,
          testData: action.payload,
        };

      case "SET_WHAT": {
        return {
          ...state,
          what: action.payload,
        };
      }
      case "RESET_TEST_TEMP":
        return initData;
      default:
        return state;
    }
  };
  const [testTempData, dispatchTestTempData] = useReducer(reducer, initData);

  useEffect(() => {
    if (!helperC.testTempModal) {
      dispatchTestTempData({ type: "RESET_TEST_TEMP" });
    }
  }, [helperC.testTempModal]);

  const handleTestTemp = (myTestData, index, what = "") => {
    console.log("myTestData", myTestData, "index", index, "what", what);
    dispatchTestTempData({
      type: "SET_TEST_DATA",
      payload: myTestData,
    });
    dispatchTestTempData({ type: "SET_WHAT", payload: what });
    dispatchTestTempData({ type: "TEST_INDEX", payload: index });
    dispatchHelper({ type: "SET_TEST_TEMP_MODAL", payload: true });
  };

  useEffect(() => {
    allTestListGet(props.globalState, dispatchAllTest);
  }, []);

  const tests = allTestC.allTest;

  return (
    <Container className="mb-4 mt-4 container-width-fix">
      <Card className="">
        <CardBody className="responsive-custom-card-body">
          <Row>
            <div className="responsive-test-card-header">
              <div className="">
                <h3
                  style={{
                    color: "#444",
                  }}
                >
                  Flagged Question
                </h3>
              </div>

              <div
                className=""
                style={{
                  display: "flex",
                }}
              >
                {/* <select
                  // onChange={(e) => {
                  //   setSortType(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: e.target.value,
                      filterBy,
                      orderBy,
                    })
                  }
                  value={sortByValue || "group"}
                  className="form-control mb-3 form-control-sm ml-2 mr-2"
                  placeholder="Sort By"
                >
                  <option value="NA">--- Sort By ---</option>
                  <option value="testName">Name</option>
                  <option value="group">Group</option>
                  <option value="actionTag">Action Tag</option>
                </select>
                <Radio.Group
                  // onChange={(e) => {
                  //   setOrderBy(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: sortByValue,
                      filterBy,
                      orderBy: e.target.value,
                    })
                  }
                  value={orderBy}
                  optionType="button"
                  buttonStyle="solid"
                  className={"rad-btns"}
                >
                  <Radio.Button
                    className={`radio-btn-ctm `}
                    buttonStyle="solid"
                    value={"asc"}
                  >
                 
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-down"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                      />
                    </svg>
                  </Radio.Button>
                  <Radio.Button
                    className={`radio-btn-ctm`}
                    buttonStyle="solid"
                    value={"dsc"}
                  >
              
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-up"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                      />
                    </svg>
                  </Radio.Button>
                </Radio.Group> */}
              </div>
            </div>

            <Col md="12">
              <div className="pr-2">
                <FormGroup>
                  {/* <Input
                    // onKeyUp={this.filterStudent}
                    bsSize="sm"
                    // id="exampleFormControlInput1"
                    placeholder="Search Test"
                    // type="email"
                  /> */}
                  {/* <select
                    // onChange={this.changeLevel}
                    className="form-control mt-2 mb-3 form-control-sm "
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select> */}
                </FormGroup>
                <div style={{ height: "80vh", overflowY: "auto" }}>
                  <table className="table  table-striped">
                    <thead>
                      <tr>
                        <th className="small py-2 ">Ques Id.</th>
                        <th className="small py-2">Created By</th>
                        <th className="small py-2">Created Date</th>
                        <th className="small py-2">Correct Text</th>
                        <th className="small py-2">Correct Choice</th>
                        <th className="small py-2">Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arrayValidation(tests) &&
                        tests.map((test, index) => {
                          return (
                            <>
                              <tr
                                key={index}
                                className="test-name-accessor"
                                style={{ cursor: "pointer" }}
                                // onClick={() => handleTestClick(test)}
                              >
                                <td>
                                  <span
                                    onClick={() => {
                                      // handleTestTemp(item, i, "");
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                      color: "#2b72fe",
                                    }}
                                  >
                                    123
                                    {/* {item.que_id} */}
                                  </span>
                                </td>

                                <td className="py-2 test-name-accessor d-flex">
                                  <Tooltip title={test.intro3}>
                                    <span
                                      className="test-name-span"
                                      style={{
                                        fontWeight: "400",
                                        color: "#000",
                                      }}
                                    >
                                      created by{/* {test.test_name} */}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td
                                  className="py-2"
                                  style={{
                                    fontWeight: "400",
                                    color: "#000",
                                  }}
                                >
                                  created on {test.group_name}
                                </td>
                                <td
                                  className="py-2"
                                  style={{
                                    fontWeight: "400",
                                  }}
                                >
                                  created text {test.action_tag}
                                </td>
                                <td
                                  className="py-2"
                                  style={{
                                    fontWeight: "400",
                                  }}
                                >
                                  created choice {test.action_tag}
                                </td>
                                <td
                                  className="py-2"
                                  style={{
                                    fontWeight: "400",
                                  }}
                                >
                                  Comment{" "}
                                </td>
                              </tr>
                              <TestTempModal testTempData={testTempData} />
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};

const mapToProp = (state) => {
  return {
    globalState: state.globaReducer,
    filterProps: state.filterStateReducer,
    allTest: state.offlineSyncReducer.allTest,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleSetParams: (params) => dispatch(setParams(params)),
    handleSortAndOrderChange: (data) => dispatch(setSortByState(data)),
    fetchAllOfflineSyncTest: () => dispatch(fetchAllOfflineSyncTest()),
  };
};

export default connect(mapToProp, mapDispatchToProps)(FlagedQuestion);
